(function($) {$(document).ready(function() {

	$('.term-dates__col-title').on('click', event => {
		if (window.innerWidth >= 1024) return;

		const $this = $(event.target);

		$this
			.closest('.term-dates__col')
			.toggleClass('open')
			.find('.term-dates__content')
			.slideToggle();
	});

	// Columns to open on load
	$('.term-dates__col.open-on-load')
		.addClass('open')
		.find('.term-dates__content')
		.show();

});;jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);